import React from "react";

const TaskError = props => <div>{props.intentionally.broken}</div>;

export default TaskError;
